import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import AdminRegisterScreen from "./screens/AdminRegisterScreen";
import DashboardScreen from "./screens/DashboardScreen";
import ClassRouteWrapper from "./screens/ClassRouteWrapper";
import StudentsRouteWrapper from "./screens/StudentsRouteWrapper";
import TeachersRouteWrapper from "./screens/TeachersRouteWrapper";
import AttendanceRouteWrapper from "./screens/AttendanceRouteWrapper";
import Homeworks from './screens/Homeworks';
import HomeworkView from './screens/HomeworkView';
import NoticeBoard from './screens/NoticeBoard';
import AppPages from './screens/AppPages';
import DeviceManagement from './screens/biometric/DeviceManagement';
import SyncLogs from './screens/biometric/SyncLogs';
import PrivateRoute from "./components/PrivateRoute";
import { ToastProvider, useToast } from "./contexts/ToastContext";
import ToastContainer from "./components/ui/ToastContainer";
import "./App.css";

function AppContent() {
  const { toasts, removeToast } = useToast();

  return (
    <>
      <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/secure-admin-setup-portal" element={<AdminRegisterScreen />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <DashboardScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/students"
            element={
              <PrivateRoute>
                <StudentsRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/students/:id"
            element={
              <PrivateRoute>
                <StudentsRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/students/:id/edit"
            element={
              <PrivateRoute>
                <StudentsRouteWrapper isEdit={true} />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <PrivateRoute>
                <TeachersRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff/:id"
            element={
              <PrivateRoute>
                <TeachersRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff/:id/edit"
            element={
              <PrivateRoute>
                <TeachersRouteWrapper isEdit={true} />
              </PrivateRoute>
            }
          />
          <Route
            path="/classes"
            element={
              <PrivateRoute>
                <DashboardScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/classes/:id"
            element={
              <PrivateRoute>
                <ClassRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/classes/:id/edit"
            element={
              <PrivateRoute>
                <ClassRouteWrapper isEdit={true} />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <PrivateRoute>
                <AttendanceRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance/students"
            element={
              <PrivateRoute>
                <AttendanceRouteWrapper />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance/teachers"
            element={
              <PrivateRoute>
                <DashboardScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/fees"
            element={
              <PrivateRoute>
                <DashboardScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/homeworks"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <Homeworks />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
          <Route
            path="/homeworks/:id"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <HomeworkView />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
          <Route
            path="/notice-board"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <NoticeBoard />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-pages"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <AppPages />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
          <Route
            path="/biometric/devices"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <DeviceManagement />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
          <Route
            path="/biometric/logs"
            element={
              <PrivateRoute>
                <DashboardScreen>
                  <SyncLogs />
                </DashboardScreen>
              </PrivateRoute>
            }
          />
      </Routes>
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </>
  );
}

function App() {
  return (
    <ToastProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="app">
          <AppContent />
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
